export interface WindowWithParentOrigin extends Window {
  parentOrigin?: string
}

export function postMessageToParentWindow(msg: Record<string, any>) {
  const { parentOrigin } = window as WindowWithParentOrigin

  if (parentOrigin) {
    window.parent.postMessage(msg, parentOrigin)
  }
}

export function initiateDownload(url: string): void {
  // TODO: Use a safer way to download files.
  window.location.href = url
}

export function initiateDownloadFromPost(
  action: string,
  fields: Record<string, string> = {},
): void {
  const form = document.createElement("form")
  form.method = "POST"
  form.action = action
  form.style.display = "none"
  form.target = "_blank"

  for (const [name, value] of Object.entries(fields)) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value
    form.appendChild(input)
  }

  document.body.appendChild(form)
  form.submit()
  form.remove()
}
